var VerificationCompleteStatus;
(function (VerificationCompleteStatus) {
    VerificationCompleteStatus[VerificationCompleteStatus["USER_CANCELLED"] = 0] = "USER_CANCELLED";
    VerificationCompleteStatus[VerificationCompleteStatus["COMPLETE_SUCCESS"] = 1] = "COMPLETE_SUCCESS";
})(VerificationCompleteStatus || (VerificationCompleteStatus = {}));

export { VerificationCompleteStatus };
